import { render, staticRenderFns } from "./BaseDummyAvatar.vue?vue&type=template&id=60ec71b6"
import script from "./BaseDummyAvatar.vue?vue&type=script&lang=js"
export * from "./BaseDummyAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports